// src/composables/windowSizeShared.js
import { ref, computed } from 'vue'

const width = ref(window.innerWidth)
const height = ref(window.innerHeight)

function updateSize() {
  width.value = window.innerWidth
  height.value = window.innerHeight
}

// Add event listener immediately (or create a start function you call once)
window.addEventListener('resize', updateSize)

// Export reactive values and isMobile computed
export { width, height }

export const isMobile = computed(() => width.value < 700)
